/**
 * TA-335. One owner sign-off on one Playbook pattern, as the playcard reads
 * it.
 *
 * F-15 (CLAUDE.md section 13, vault B4): single-client patterns ship as
 * "owner-ratified provisional": n>=5 consistent threads + explicit owner
 * sign-off + ship-with-expiry. B15.3: "Every shipped update carries
 * predeclared invalidators + a review-by date." Until TA-335 a sign-off was a
 * bare pattern id, so one passed in would have rendered forever.
 *
 * In core because both halves need it and neither may import the other:
 * `packages/db/src/patternRatifications.ts` folds the owner's decisions into
 * these, and `packages/agents/src/playcard.ts` renders from them. The db
 * package depends on core and never on agents.
 */
export interface RatifiedPattern {
  /** The Playbook's stable pattern id (`stage4.ts` PATTERN_DEFS), e.g. `price_objection_hold`. */
  readonly patternId: string;
  /**
   * B15.3's review-by date, as an ISO 8601 instant. The pattern clears only
   * while this is strictly after the reader's own now; the store refuses one
   * that is not, and the playcard judges it again on every build, because a
   * sign-off that was live when it was read can lapse while an agent runs.
   */
  readonly expiresAt: string;
}
